import { render, staticRenderFns } from "./ConvertToOrganizationDialog.vue?vue&type=template&id=5be489fe&scoped=true"
import script from "./ConvertToOrganizationDialog.vue?vue&type=script&lang=js"
export * from "./ConvertToOrganizationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be489fe",
  null
  
)

export default component.exports